import React, { useEffect, useRef } from "react";
import Day from "./Day";
import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";

dayjs.extend(isoWeek);

export default function Week({ currentDate }) {
  // Get start of ISO week (Monday)
  const startOfWeek = currentDate.startOf('isoWeek');
  const days = Array.from({ length: 7 }, (_, i) => startOfWeek.add(i, 'day'));
  
  // Generate hour labels (00:00 to 23:00)
  const hours = Array.from({ length: 24 }, (_, i) => i);
  
  const scrollContainerRef = useRef(null);
  
  // Scroll to 8 AM on mount
  useEffect(() => {
    if (scrollContainerRef.current) {
      // 8 AM = 8 hours * 60px per hour = 480px
      // Add a small delay to ensure DOM is fully rendered
      setTimeout(() => {
        scrollContainerRef.current.scrollTop = 480;
      }, 0);
    }
  }, []);
  
  return (
    <div className="flex-1 flex overflow-hidden">
      {/* Hour labels on all screen sizes */}
      <div className="flex-shrink-0 w-12 md:w-16 border-r border-gray-200 dark:border-gray-800 bg-gray-50 dark:bg-gray-900 overflow-y-auto">
        {/* Header spacer - matches Day component header height */}
        <div className="flex flex-col items-center">
          <p className="text-xs md:text-sm p-0.5 md:p-1 my-0 md:my-1 invisible">00</p>
        </div>
        {hours.map(hour => (
          <div 
            key={hour} 
            className="text-xs md:text-sm text-gray-500 text-right pr-1 md:pr-2 border-t border-gray-100"
            style={{ height: '60px', paddingTop: '4px' }}
          >
            {hour.toString().padStart(2, '0')}:00
          </div>
        ))}
      </div>
      
      {/* Week grid */}
      <div ref={scrollContainerRef} className="flex-1 grid grid-cols-7 grid-rows-1 overflow-y-auto">
        {days.map((day, idx) => (
          <Day day={day} key={idx} rowIdx={0} viewMode="week" />
        ))}
      </div>
    </div>
  );
}
